import { Column } from 'primereact/column';
import { useState } from 'react';

import { DialogPopUpComponent } from '../../../components/DialogPopUpComponent';
import { TableComponent } from './../../../components/Table';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';
import { PopUpComponent } from '../../../components/PopUpComponent';
import { ActivePopUp } from '../../../interfaces/interfaceInventory';
import { columnsDisplayRechargeCounterHistory } from './table/helper';

interface IWhiteListSamProps {
  serviceInventory: IInventoryProvider;
}

export const RechargesCounterHistoryModal = (props: IWhiteListSamProps) => {
  const { serviceInventory } = props;

  const bodyContent = () => {
    return (
      <div className="w-full h-80 mb-8 flex p-6 justify-center relative shadow-2xl rounded-2xl border-t-[1px] border-grey ">
        <TableComponent
          value={serviceInventory.selectedSamToHistoryRechargeModal}
          // loading={getSamByIdState.loading}
          sortField="name"
          responsiveLayout="scroll"
          className="flex h-full w-full rounded relative"
          resizableColumns
          // reorderableColumns={true}
        >
          {columnsDisplayRechargeCounterHistory.map(
            (column: any, index: any) => {
              const key = index.toString();
              return (
                <Column
                  key={key}
                  field={column.field}
                  header={column.header}
                  bodyClassName="!text-grey !text-[12px]"
                  headerClassName="!font-bold !justify-between !bg-white !text-grey"
                  style={{
                    flexGrow: 1,
                    flexBasis: '100px',
                  }}
                  body={column.body}
                />
              );
            }
          )}
        </TableComponent>
      </div>
    );
  };

  return (
    <PopUpComponent
      header={`Historial de contadores para la SAM ${serviceInventory.samInfo?.SamId}`}
      showPopUp={
        serviceInventory.activePopUp === ActivePopUp.RechargeCounterHistory &&
        serviceInventory.showPopUp
      }
      onSubmit={() => ({})}
      onClosePopUp={() => serviceInventory.closePopUp()}
      body={bodyContent()}
      footer={false}
    />
  );
};
